import React, { useEffect, useState } from "react";
import AttendanceCheckbox from "../../components/AttendanceCheckbox";
import DateRange from "../../components/Employee/AttendanceSummary/DateRange";
import Table from "../../components/Employee/Table";
import { useGetAllAttendancePaginated } from "../../hooks/useAttendance";
import {
  formatDateOnly,
  formatTime12Hour,
  getDateMonthsAgo,
  getMediaBase64,
} from "../../util/common";
import { useEmployeePrivateAssets } from "../../hooks/useAssets";

function AttendanceSummary() {
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const [pageCount, setPageCount] = useState(1);

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
  });

  const [filter, setFilter] = useState({
    DateFrom: formatDateOnly(getDateMonthsAgo(1)),
    DateTo: formatDateOnly(new Date()),
    OrderBy: "desc",
  });

  const attendance = useGetAllAttendancePaginated();

  const fetchAttendanceRecords = async () => {
    attendance.mutate(
      {
        page: pagination.page,
        pageSize: pagination.pageSize,
        filters: filter,
      },
      {
        onSuccess: async (result) => {
          if (!result.success) return;

          const records = await Promise.all(
            result.data.data.map(async (record) => {
              return {
                AttendanceDate: formatDateOnly(record.AttendanceDate),
                TimeIn: formatTime12Hour(record.TimeIn),
                TimeOut: formatTime12Hour(record.TimeOut),
                TotalHours: record.TotalHours || 0,
                FileAttached1Media: await getMediaBase64(
                  record?.FileAttached1Media?.MediaUrl
                ),
                FileAttached2Media: await getMediaBase64(
                  record?.FileAttached2Media?.MediaUrl
                ),
              };
            })
          );

          setAttendanceRecords(records);
          setPageCount(result.data.pagination.totalPages);
        },
        onError: (error) => {
          console.error("Fetch error:", error);
        },
      }
    );
  };

  useEffect(() => {
    fetchAttendanceRecords();
  }, [pagination, filter]);

  const tableColumns = [
    { accessorKey: "AttendanceDate", header: "Date" },
    { accessorKey: "TimeIn", header: "Time In" },
    { accessorKey: "TimeOut", header: "Time Out" },
    { accessorKey: "TotalHours", header: "Total Hours" },
    {
      accessorKey: "FileAttached1Media",
      header: "Time In Capture",
      cell: ({ getValue }) => {
        const url = getValue();
        if (!url) return "No Image";
        return (
          <img
            src={url}
            alt="Time In"
            style={{
              width: "60px",
              height: "60px",
              objectFit: "cover",
              borderRadius: "6px",
            }}
          />
        );
      },
    },
    {
      accessorKey: "FileAttached2Media",
      header: "Time Out Capture",
      cell: ({ getValue }) => {
        const url = getValue();
        if (!url) return "No Image";
        return (
          <img
            src={url}
            alt="Time Out"
            style={{
              width: "60px",
              height: "60px",
              objectFit: "cover",
              borderRadius: "6px",
            }}
          />
        );
      },
    },
  ];

  const handleOnPageChange = (pageIndex, pageSize) => {
    setPagination({
      page: pageIndex + 1,
      pageSize,
    });
  };

  return (
    <div className="overtime-form-container">
      <h2>Attendance Summary</h2>
      <form className="overtime-form">
        <DateRange
          label={"Date From"}
          name={"DateFrom"}
          filter={filter}
          setFilter={setFilter}
        />
        <DateRange
          label={"Date To"}
          name={"DateTo"}
          filter={filter}
          setFilter={setFilter}
        />

        <div className="form-group full-width file-upload-section">
          <div className="attendance-filters">
            {/* <h3>Attendance Filters</h3> */}
            {/* <AttendanceCheckbox /> */}

            <div className="attendance-records">
              <h3>Attendance Records</h3>

              <Table
                data={attendanceRecords}
                columns={tableColumns}
                mode="server"
                initialPageSize={pagination.pageSize}
                onPageChange={handleOnPageChange}
                pageCount={pageCount}
                page={pagination.page - 1}
                pageSize={pagination.pageSize}
              />
            </div>
          </div>
        </div>

        <button type="submit" className="submit-btn">
          Generate
        </button>
      </form>
    </div>
  );
}

export default AttendanceSummary;
